/**
 * 
 */
export const captcha_environment = {

    RECAPTCHA: {
        siteKey: '** REEMPLAZAR CON SITE KEY DE reCAPTCHA **',
    }

}